import moment from "moment";
moment.updateLocale("pt-br", {
  months: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split(
    "_"
  ),
  monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
  weekdays: "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split(
    "_"
  ),
  weekdaysShort: "dom_seg_ter_qua_qui_sex_sáb".split("_"),
  weekdaysMin: "dom_2ª_3ª_4ª_5ª_6ª_sáb".split("_"),
  longDateFormat: {
    LT: "HH:mm",
    L: "DD/MM/YYYY",
    LL: "D [de] MMMM [de] YYYY",
    LLL: "D [de] MMMM [de] YYYY [às] LT",
    LLLL: "dddd, D [de] MMMM [de] YYYY [às] LT"
  },
  calendar: {
    sameDay: "[Hoje às] LT",
    nextDay: "[Amanhã às] LT",
    nextWeek: "dddd [às] LT",
    lastDay: "[Ontem às] LT",
    lastWeek: function() {
      return this.day() === 0 || this.day() === 6
        ? "[Último] dddd [às] LT" // Saturday + Sunday
        : "[Última] dddd [às] LT"; // Monday - Friday
    },
    sameElse: "L"
  },
  relativeTime: {
    future: "em %s",
    past: "%s",
    s: "1s",
    m: "1min",
    mm: "%dmin",
    h: "1h",
    hh: "%dh",
    d: "1d",
    dd: "%dd",
    M: "1m",
    MM: "%dm",
    y: "1a",
    yy: "%da"
  },
  ordinal: "%dº"
});

export const Types = {
  ADD_FILTERS: "filtrosBonusDesconto/ADD_FILTERS",
  SET_FILTRO_BONUS_DESCONTO: "filtrosBonusDesconto/SET_FILTRO_BONUS_DESCONTO"
};

const INITIAL_STATE = {
  openFiltro: true,
  date_type: "created_at-Data cadastro",
  initial_date: new Date(new Date().getFullYear(), new Date().getMonth()),
  finish_date: new Date(),
  type: "",
  destinable_type: "",
  category_ids: [],
  destinable_ids: []
};

export default function filtrosBonusDesconto(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.ADD_FILTERS:
      return {
        ...state,
        date_type: action.payload.data.date_type,
        initial_date: action.payload.data.initial_date,
        finish_date: action.payload.data.finish_date,
        type: action.payload.data.type,
        destinable_type: action.payload.data.destinable_type,
        category_ids: action.payload.data.category_ids,
        destinable_ids: action.payload.data.destinable_ids
      };
    case Types.CLOSE:
      return { ...state, open: false };
    case Types.SET_FILTRO_BONUS_DESCONTO:
      return { ...state, openFiltro: action.payload.data };
    default:
      return state;
  }
}

export const Creators = {
  addBonusDescontoFiltro: data => ({
    type: Types.ADD_FILTERS,
    payload: { data }
  }),
  setFiltroBonusDesconto: data => ({
    type: Types.SET_FILTRO_BONUS_DESCONTO,
    payload: { data }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/filtrosBonusDesconto.js